import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogTitle, DialogContent, List, ListItem, ListItemText, } from "@material-ui/core";
import { Link } from "react-router-dom";
import { complaintTypesService } from "../../services";
const useStyles = makeStyles({
    paper: {
        position: "absolute",
        right: "-30px",
        top: "70px",
    },
    titleStyle: {
        "& h2": {
            fontWeight: "600",
            color: "#949494",
            fontSize: "1.2em",
        },
    },
    contentStyle: {
        color: "#515151",
    },
});
export const NewComplaintDialog = ({ isDialogOpen, onDialogClose, }) => {
    const [complaintTypes, setComplaintTypes] = useState([]);
    useEffect(() => {
        complaintTypesService.getAll().then(response => setComplaintTypes(response.data));
    }, []);
    const dialogStyles = useStyles();
    return (React.createElement(Dialog, { open: isDialogOpen, onClose: () => onDialogClose(), maxWidth: "sm", classes: { paper: dialogStyles.paper } },
        React.createElement(DialogTitle, { classes: { root: dialogStyles.titleStyle } }, "New Case Type"),
        React.createElement(DialogContent, { dividers: true, classes: { root: dialogStyles.contentStyle } },
            React.createElement(List, { component: "nav" }, complaintTypes.map(complaintType => (React.createElement(ListItem, { button: true, key: complaintType.id, classes: { root: dialogStyles.contentStyle }, component: Link, to: `/complaints/new?caseType=${complaintType.id}`, "data-test": "new-complaint-links" },
                React.createElement(ListItemText, { primary: complaintType.name }))))))));
};
